import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class TokenService {
	private cToken?: string;
	private icecode?: string;
	private phoenixKey?: string;

	constructor(private http: HttpClient) { }

	fetchJWT(cToken: string | null, icecode: string | null, phoenixKey: string | null): Observable<string> {
		if (cToken) {
			this.cToken = cToken;
		}

		if (icecode && phoenixKey) {
			this.icecode = icecode;
			this.phoenixKey = phoenixKey;
		}
		return this.getToken();
	}

	/**
	 * This needs to return a subject to mirror the return type of GigyaService.refreshToken
	 */
	refreshToken(): Observable<string> {
		const newToken = new Subject<string>();
		this.getToken().subscribe(
			(token) => {
				newToken.next(token);
			},
			(err) => {
				newToken.error(err);
			}
		);
		return newToken;
	}

	private getToken(): Observable<string> {
		let params: HttpParams = new HttpParams();
		if (this.cToken) {
			params = params.append('cToken', this.cToken);
		}

		if (this.icecode && this.phoenixKey) {
			params = params.append('i', this.icecode).append('p', this.phoenixKey);
		}

		// * No parameters will return 404 Not Found
		// * Invalid parameters will return 400 Bad Request
		// * If the Customer ID cannot be resolved, then the API will return 204 no content
		// * If the Customer ID can be resolved then the API will return 200 OK with the JWT
		return this.http.get<string>('/api/pre-auth/jwt', { params, observe: 'response' }).pipe(
			map((res) => {
				if (res.status === 200 && res.body) {
					return res.body;
				}
				throw new Error('Could not fetch token');
			}),
			catchError(() => throwError(new Error('Could not fetch token')))
		);
	}
}
